@if (requestsTotal()) {
  <div class="requests-actions">
    <div class="requests-count">
      You have <span> {{ requestsTotal() }} </span> requests
    </div>

  </div>

  <div #scrollRequestsContainer class="grid-container" (scroll)="onRequestsScroll()">
    @for (request of requestsList(); track request.id) {
      <app-request-card (eventTriggered)="onEvent($event)" [request]="request"></app-request-card>
    }
  </div>
} @else {
  <div class="empty-screen">
    <div class="header">
      List is empty
    </div>
    <div class="sub-header">
      You have no requests for now
    </div>

  </div>
}
